import type { IntercomUser } from "./types";

const updateIntercomUser = (intercomUser?: IntercomUser): void => {
  if (!intercomUser || window.intercomUserLoaded) {
    return;
  }

  window.intercomSettings = {
    ...window.intercomSettings,
    user_id: intercomUser.user_id,
    email: intercomUser.email,
    name: intercomUser.name,
    intercom_user_jwt: intercomUser.intercom_user_jwt,
  };
  window.intercomUserLoaded = true;

  if (typeof window.Intercom === "function") {
    window.Intercom("update", window.intercomSettings);
  }
};

const setupIntercomUser = (): void => {
  window.intercomUserLoaded = window.intercomUserLoaded || false;
  window.updateIntercomUser = updateIntercomUser;
};

export { setupIntercomUser };
